<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block yellow-theme">
  <mat-card-header>
    <mat-card-title ><b>Obrazac C2 - Izvješće o troškovima</b></mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="expenditureReportForm">
      <!-- Reporting Period Section -->
      <h3>Razdoblje Izvješća</h3>
      <div class="reporting-period">
        <mat-form-field appearance="fill" class="mb-25">
          <mat-label>Početni Datum</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="reportingPeriodStart" [max]="expenditureReportForm.get('reportingPeriodEnd')?.value || null">
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill" class="mb-25">
          <mat-label>Krajnji Datum</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="reportingPeriodEnd" [min]="expenditureReportForm.get('reportingPeriodStart')?.value || null">
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <!-- Direct Expenditures Section -->
      <h3>POGLAVLJE A) IZRAVNI TROŠKOVI</h3>
      <mat-accordion formArrayName="directCosts">
        @for (expenditureItem of directCosts.controls; track expenditureItem; let i = $index) {
          <mat-expansion-panel #directPanel [formGroupName]="i">
            <mat-expansion-panel-header class="no-wrap-header">
              <mat-panel-title>
                {{ expenditureItem.get('description')?.value }}
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="actions">
              <button mat-icon-button type="button" color="primary" (click)="closePanel(directPanel)" matTooltip="Završi uređivanje stavke" [disabled]="expenditureItem.invalid">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button type="button" color="warn" (click)="removeExpenditureItem(costType.Direct, i)" matTooltip="Ukloni stavku">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            <mat-form-field class="mb-25">
              <mat-label>Opis</mat-label>
              <textarea #directDescriptionInputs matInput formControlName="description" ></textarea>
            </mat-form-field>
            <mat-form-field class="mb-25">
              <mat-label>Ugovoreni iznos sredstava u eurima</mat-label>
              <input matInput formattedNumber [config]="{ decimals: 2, useThousands: false, maxDigits: 10 }" formControlName="contractedFundsAmount" >
            </mat-form-field>
            <mat-form-field class="mb-25">
              <mat-label>Iznos ostvarenih prihvatljivih troškova (EUR)</mat-label>
              <input matInput formattedNumber [config]="{ decimals: 2, useThousands: false, maxDigits: 10 }" formControlName="realizedEligibleCosts" >
            </mat-form-field>
            <app-file-upload [storageLocation]="expenditureItem.get('fileStorageLocation')?.value"></app-file-upload>
          </mat-expansion-panel>
        }
      </mat-accordion>


      <button mat-raised-button type="button" color="primary" (click)="addExpenditureItem(costType.Direct)">
        Dodaj Izravni Trošak
      </button>

      <!-- Totals for Direct Expenditures -->
      <div class="totals">
        <h4>Ukupno Ugovorenih Sredstava: {{ totalDirectContractedFunds | currency:'EUR' }}</h4>
        <h4>Ukupno Realiziranih Prihvatljivih Troškova: {{ totalDirectRealizedCosts | currency:'EUR' }}</h4>
      </div>

      <!-- Indirect Expenditures Section -->
      <h3>POGLAVLJE B) NEIZRAVNI TROŠKOVI</h3>
      <mat-accordion formArrayName="indirectCosts">
        @for (expenditureItem of indirectCosts.controls; track expenditureItem; let i = $index) {
          <mat-expansion-panel #indirectPanel [formGroupName]="i">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ expenditureItem.get('description')?.value }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="actions">
              <button mat-icon-button type="button" color="primary" (click)="closePanel(indirectPanel)" matTooltip="Završi uređivanje stavke" [disabled]="expenditureItem.invalid">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button type="button" color="warn" (click)="removeExpenditureItem(costType.Indirect, i)" matTooltip="Ukloni stavku">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            <mat-form-field class="mb-25">
              <mat-label>Opis</mat-label>
              <textarea #indirectDescriptionInputs matInput formControlName="description" ></textarea>
            </mat-form-field>
            <mat-form-field class="mb-25" appearance="fill">
              <mat-label>Ugovoreni iznos sredstava u eurima</mat-label>
              <input matInput formattedNumber [config]="{ decimals: 2, useThousands: false, maxDigits: 10 }" formControlName="contractedFundsAmount" >
            </mat-form-field>
            <mat-form-field class="mb-25" appearance="fill">
              <mat-label>Realizirani Prihvatljivi Troškovi (EUR)</mat-label>
              <input matInput formattedNumber [config]="{ decimals: 2, useThousands: false, maxDigits: 10 }" formControlName="realizedEligibleCosts" >
            </mat-form-field>
            <app-file-upload [storageLocation]="expenditureItem.get('fileStorageLocation')?.value"></app-file-upload>
          </mat-expansion-panel>
        }
      </mat-accordion>

      <button mat-raised-button type="button" color="primary" (click)="addExpenditureItem(costType.Indirect)">
        Dodaj Neizravni Trošak
      </button>

      <!-- Totals for Indirect Expenditures -->
      <div class="totals">
        <h4>Ukupno Ugovorenih Sredstava: {{ totalIndirectContractedFunds | currency:'EUR' }}</h4>
        <h4>Ukupno Realiziranih Prihvatljivih Troškova: {{ totalIndirectRealizedCosts | currency:'EUR' }}</h4>
      </div>

      <!-- Overall Totals -->
      <div class="totals">
        <h3>Sveukupno:</h3>
        <h4>Ukupno Ugovorenih Sredstava: {{ totalContractedFunds | currency:'EUR' }}</h4>
        <h4>Ukupno Realiziranih Prihvatljivih Troškova: {{ totalRealizedEligibleCosts | currency:'EUR' }}</h4>
        <h4>Ukupni Troškovi: {{ totalExpenditure | currency:'EUR' }}</h4>
      </div>

      <!-- Submit Button -->
      <button mat-raised-button type="submit" color="accent" class="submit-btn" (click)="onSubmit()"  [disabled]="expenditureReportForm.invalid">
        {{ expenditureReport ? 'Ažuriraj Izvješće o Troškovima' : 'Kreiraj Izvješće o Troškovima' }}
      </button>
    </form>
  </mat-card-content>
</mat-card>
